module.exports = __webpack_public_path__ + "static/media/Construyamos.8d3d6eb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Section-servicios/Images/Construyamos.svg
// module id = 133
// module chunks = 0